import React from 'react';
import s from './HomeDetails.module.css';
export default function DetailState({title,description,pending=false,retry}) {
  return <div className={s.state} role={retry?'alert':'status'} aria-busy={pending}>
    {pending&&<span className={s.loading} aria-hidden="true"/>}<strong>{title}</strong>
    {description&&<p>{description}</p>}
    {retry&&<button type="button" className={s.button} onClick={retry}>Try again</button>}
  </div>;
}
